






























































import BaseComponent from "@/components/base/BaseComponent";
import {MemberType} from "@/components/dashboard/process-management/model/ProcessManagmentTypes";
import {Component, Prop} from 'vue-property-decorator';

@Component({
})
export default class LegallyWithdrawingFunds extends BaseComponent {

  @Prop(Number) memberType: any

  private employeeBenefitWithdrawal: number | null = 0; // Default to 0
  private benefitPartWithdrawValue: string = "0"; // Default to '0'




  private onRadioChange(value: number): void {
    console.log("value", value)
    this.employeeBenefitWithdrawal = value;

    this.$emit("handleRadioSelectionChange", value);
  }

  get isSelfEmployed() {
    return this.memberType == MemberType.SELF_EMPLOYED;
  }

  get isEmployee() {
    return this.memberType == MemberType.EMPLOYEE
  }

  clearIllegalWithdrawalRadioChoice() {
    this.employeeBenefitWithdrawal = null

    this.$emit("handleRadioSelectionChange", null);
  }
}
